import React from "react";
import { dialog } from "../../../../nq-component";

function DialogContinue({ handleSubmit }) {
  return (
    <>
      <div className="p-4">
        <div className="d-flex flex-column align-items-center gap-3">
          <div className="d-flex align-self-start align-items-center gap-2">
            <i
              className="bi bi-question-circle fs-2 px-2 rounded"
              style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
            ></i>
            <h5 className="fw-bold mt-2" style={{ color: "#D18237" }}>
              Continue
            </h5>
          </div>
        </div>
        <p className="ms-5">Are you sure want to continue?</p>
      </div>

      <div className="text-center mb-3">
        <button
          type="submit"
          className="btn text-white me-2"
          style={{ backgroundColor: "#D18237" }}
          onClick={() => handleSubmit()}
        >
          Confirm
        </button>
        <button
          type="button"
          className="btn"
          style={{ backgroundColor: "#e8ecf3" }}
          onClick={() => dialog.close()}
        >
          Cancel
        </button>
      </div>
    </>
  );
}

export default DialogContinue;
